<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://munad.jgmun.com" target="_blank"
          >MUNAD</a
        > | Sistema de Control de Evidencias
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
